import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import queryString from 'query-string';
import { adminApi } from '@/services/api';
import { pages } from '@/settings/pages';
import { useApiErrorHandler } from '@/hooks/useApiErrorHandler';
import { useAppSelector } from '@/store';
import { authStore } from '@/store/auth';
import { FROM_PATH_KEY } from '@/constants';

export const useCheckReAuthenticationExpiration = (
  setIsLoading: (isLoading: boolean) => void,
  fromPath: string,
) => {
  const { apiErrorHandler } = useApiErrorHandler();
  const navigate = useNavigate();
  const gloplaId = useAppSelector(authStore.selectors.gloplaIdSelector);

  return useCallback(async () => {
    // ログアウト処理(persistor.purge)で gloplaId が消えた後の再発火では、
    // トークン無しのままAPIが「再認証必要」と誤判定し、ログアウト後に戻り先を書き直してしまうため何もしない
    if (!gloplaId) return;

    setIsLoading(true);

    try {
      const isReAuthenticationExpired =
        await adminApi.getReAuthenticationExpiration();
      if (isReAuthenticationExpired) {
        const queryParams = {
          prompt: 'login',
          [FROM_PATH_KEY]: fromPath,
          glopla_id: gloplaId,
        };
        const signinUri = queryString.stringifyUrl({
          url: pages.signin.index,
          query: queryParams,
        });
        navigate(signinUri);
      } else {
        setIsLoading(false);
      }
    } catch (err) {
      apiErrorHandler(err);
    }
  }, [apiErrorHandler, gloplaId, navigate, setIsLoading, fromPath]);
};
